import { SET_FILE_CONTENT_RESULT } from './file-download-mutation-types';
import buildRoute from '@/composables/build-route';
import { cloneDeep } from 'lodash';
import downloadBinaryFile from '@/utils/download-binary-file';
import apiService from '@/services/api-service';

const initialState = {
	fileContentResult: {}
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'fileDownload',
	namespaced: true,
	state: cloneDeep(initialState),
	mutations: {
		[SET_FILE_CONTENT_RESULT](state, fileContentResult) {
			state.fileContentResult = fileContentResult;
		}
	},
	actions: {
		async getFileContentResultAction({ commit }, { apiPath, params }) {
			const path = buildRoute(apiPath, params);
			const result = await apiService.getRawResponse(path, {
				responseType: 'blob'
			});
			commit(SET_FILE_CONTENT_RESULT, result);
		},
		async downloadFileAction(
			{ getters, dispatch },
			{ apiPath, params, reportName }
		) {
			await dispatch('getFileContentResultAction', { apiPath, params });

			downloadBinaryFile(
				reportName,
				getters.fileContentResult.headers
					? getters.fileContentResult.headers['content-type']
					: undefined,
				getters.fileContentResult.data
			);
		}
	},
	getters: {
		fileContentResult: state => state.fileContentResult
	}
};
